import classNames from 'classnames/bind';
import { filterBy, getI18ns } from 'components/hoc/index';
import { ColumnsDropzone } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { DropTarget } from 'react-dnd';
import { FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import Enums from 'utils/EnumsManager';
import { notification } from 'antd';
import { moveToZone, setActions } from '../../flow/actions';
import { CommonDraggableTag } from '../index';
import GroupModal from './Modal';
import styles from '../../index.less';

const cx = classNames.bind(styles);
const { FieldTypesInArray, DROPZONES } = Enums;
const { GROUPS, OTHERS, AGGREGATES } = DROPZONES;

const propTypes = {
  isOver: PropTypes.bool.isRequired,
  filteredData: PropTypes.array.isRequired
};

const errorMsg = text => {
  notification.error({
    duration: 3,
    message: text,
  });
};

class GroupsZone extends PureComponent {
  render() {
    const {
      isOver,
      connectDropTarget,
      filteredData,
      selectedCols
    } = this.props;
    const cols = _.filter(selectedCols, c => c && c.belongTo === GROUPS);

    return connectDropTarget(
      <div>
        <ColumnsDropzone
          isOver={isOver}
          description={
            <FormattedMessage id="page.ReportTableSetup.descriptions.groups" />
          }
          zoneTitle={
            <FormattedMessage id="page.ReportTableSetup.descriptions.groups">
              {text => <span className="required">{text}</span>}
            </FormattedMessage>
          }
        >
          {cols.map((record, i) => (
            <CommonDraggableTag
              key={record.id}
              {...record}
              index={i}
              // WARNING: Because record is an instance, all properties of the instance is accessed by getter, we have to explicit pass all necessary props on the component.
              //          Otherwise will cause issue when DnD internal access on some props.
              id={record.id}
              name={record.name}
              type={record.type}
              label={record.label}
              disabled={record.disabled}
              belongTo={record.belongTo}
              actions={record.actions}
              setActions={this.props.setActions}
              restriction={record.fieldRestricted}
              fieldDeleted={record.fieldDeleted}
              groupStyle={cx('tagGroup')}
            />
          ))}
        </ColumnsDropzone>
        <GroupModal />
      </div>
    );
  }
}

const spec = {
  // NOTES: Currently only one column can be set as a Group column.
  drop: (props, monitor, component) => {
    // get item id from drag source
    const { id, belongTo } = monitor.getItem();
    const { selectedCols, i18ns, filteredData } = props;
    if (_.isArray(selectedCols) && selectedCols.length >= 10 && belongTo !== DROPZONES.GROUPS) {
      errorMsg(i18ns.totalMax);
    }
    if (filteredData.length === 1 && belongTo !== DROPZONES.GROUPS) {
      errorMsg(i18ns.groupMax);
    } else {
      props.moveToZone(DROPZONES.GROUPS, id);
    }
  }
};
const collect = (connector, monitor) => ({
  connectDropTarget: connector.dropTarget(),
  isOver: monitor.isOver()
});
const mapStateToProps = ({ global, reportSetup }) => ({
  lang: global.language,
  data: reportSetup.sider.availableColumns,
  selectedCols: reportSetup.sider.selectedCols,
});
const mapDispatchToProps = {
  moveToZone,
  setActions
};

const enhancers = compose(
  getI18ns({
    groupMax: 'page.ReportFilters.errors.groupMax',
    totalMax: 'page.ReportFilters.errors.totalMax',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  filterBy('data', record => record.belongTo === DROPZONES.GROUPS),
  DropTarget(FieldTypesInArray, spec, collect),
  injectIntl
);

GroupsZone.propTypes = propTypes;
export default enhancers(GroupsZone);



// WEBPACK FOOTER //
// ./src/views/ReportTableSetup/components/GroupsZone/index.jsx